export const paths = [
  '/projects/:projectId/requests-for-information',
  '/projects/:projectId/requests-for-information/:action',
  '/projects/:projectId/requests-for-information/:action/:rfiId',
  '/projects/:projectId/requests-for-information/:action/:rfiId/:tabId',
];
